import './utils/resizeObserverPatch'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './styles/variables.css'
import './styles/page-common.css'
import axios from 'axios'
import { clearLoginCache, getAuthToken, getUserId, isAuthValid, isLoginRoute, LOGIN_PATH, migrateSessionLoginCache } from './utils/auth'
import { applyCachedPageTitle, loadSiteConfig } from './utils/siteConfig'

migrateSessionLoginCache()
applyCachedPageTitle()
loadSiteConfig()

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn })

function isChunkLoadError(message) {
  if (!message) return false
  return /Loading chunk [\d]+ failed|ChunkLoadError|Loading CSS chunk [\d]+ failed/i.test(String(message))
}

function reloadOnceOnChunkError() {
  const key = 'bymy_admin_chunk_reload'
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.reload()
}

router.onError((error) => {
  if (isChunkLoadError(error?.message)) {
    reloadOnceOnChunkError()
  }
})

window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || String(event?.reason || '')
  if (isChunkLoadError(msg)) {
    event.preventDefault()
    reloadOnceOnChunkError()
  }
})
app.mount('#app')

sessionStorage.removeItem('bymy_admin_chunk_reload')

let handling401 = false

function redirectToLoginIfNeeded() {
  const currentPath = router.currentRoute.value.path
  if (!handling401 && !isLoginRoute(currentPath)) {
    handling401 = true
    router.replace(LOGIN_PATH).finally(() => {
      handling401 = false
    })
  }
}

// 全局 axios 请求头：从 localStorage 读取共享登录态
axios.interceptors.request.use((config) => {
  if (!isAuthValid()) {
    const url = String(config.url || '')
    if (!url.includes('/api/login') && !url.includes('/api/captcha') && !url.includes('/api/configs/public/site')) {
      redirectToLoginIfNeeded()
      return Promise.reject(new Error('登录已过期'))
    }
  }
  const token = getAuthToken()
  const userId = getUserId()
  
  config.headers = config.headers || {}
  
  if (token) {
    // 兼容后端两种头：Authorization Bearer 和自定义 Token
    config.headers['Authorization'] = `Bearer ${token}`
    config.headers['Token'] = token
  }
  
  if (userId) {
    // 设置 userId header，后端可以从中获取当前登录用户
    config.headers['userId'] = userId
  }
  
  // 禁用浏览器缓存，确保每次都获取最新数据
  config.headers['Cache-Control'] = 'no-cache'
  config.headers['Pragma'] = 'no-cache'
  
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 || error?.message === '登录已过期') {
      const url = String(error.config?.url || '')
      const isAuthRequest = url.includes('/api/login') || url.includes('/api/captcha')
      if (!isAuthRequest) {
        clearLoginCache()
        redirectToLoginIfNeeded()
      }
    }
    return Promise.reject(error)
  }
)
